import React from 'react';

export const IconSmallDropdownLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path d="M12 15l4-4H8l4 4z" fill="#374050" />
    </svg>
);
